// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","content":"App_content__wwONY"};